import { motion } from "framer-motion";

const PETALS = [
  { left: "5%", size: 18, delay: 0, dur: 24, color: "#F472B6", tilt: 15 },
  { left: "16%", size: 12, delay: 6, dur: 30, color: "#FFD166", tilt: 80 },
  { left: "30%", size: 14, delay: 12, dur: 27, color: "#FFECD1", tilt: 45 },
  { left: "47%", size: 10, delay: 3, dur: 33, color: "#F472B6", tilt: 120 },
  { left: "62%", size: 16, delay: 9, dur: 25, color: "#FFD166", tilt: 200 },
  { left: "76%", size: 12, delay: 15, dur: 31, color: "#FFECD1", tilt: 60 },
  { left: "88%", size: 15, delay: 5, dur: 22, color: "#F472B6", tilt: 330 },
  { left: "95%", size: 11, delay: 18, dur: 29, color: "#FFD166", tilt: 150 },
];

export default function Petals() {
  return (
    <div aria-hidden="true" className="pointer-events-none fixed inset-0 z-0 overflow-hidden" data-testid="petals-layer">
      {PETALS.map((p, i) => (
        <motion.svg
          key={i}
          viewBox="0 0 16 16"
          className="absolute -top-8"
          style={{ left: p.left, width: p.size, height: p.size, opacity: 0.5 }}
          animate={{ y: ["-6vh", "110vh"], x: [0, 26, -14, 0], rotate: [p.tilt, p.tilt + 180, p.tilt + 360] }}
          transition={{ duration: p.dur, delay: p.delay, repeat: Infinity, ease: "linear" }}
        >
          <path d="M8 0C13 5 13 12 8 16C3 12 3 5 8 0Z" fill={p.color} />
        </motion.svg>
      ))}
    </div>
  );
}
